import React, { useRef, useState } from "react"
import { Box, Button, ButtonGroup, MenuItem, Select, Stack, TextField, Typography } from "@mui/material"
import { Chart } from "react-chartjs-2"
import { Chart as Chartjs, ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement, PointElement, LineElement, TimeScale } from 'chart.js';
import html2canvas from "html2canvas"
import moment from "moment";
import 'chartjs-adapter-moment';
import 'chartjs-plugin-datalabels';

Chartjs.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement, PointElement, LineElement, TimeScale);

export default function Graph(props) {
    const chart_colors = ["#2F768E", "#39A0B3", "#43CAD8", "#4DF4FD", "#61F4E8", "#75F4D3", "#89F4BE", "#9DF4A9", "#B1F494", "#C5F47F"]
    const graphs = [{label:"Camembert", value:'pie'}, {label:"Diagramme à colonnes", value:'bar'}, {label:"Linéaire", value:'line'}]
    const chartRef = useRef()
    
    const [title, settitle] = useState('')
    const [labels, setlabels] = useState([])
    const [graph_type, settype] = useState('pie')

    async function downloadChart() {
        const graphContainer = document.querySelector('#chart_container');
        const canvas = await html2canvas(graphContainer);
        const base64Image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = base64Image;
        link.download = `${title!=='' ? title : 'graph_dons'}.png`;
        document.body.appendChild(link)
        link.click();
    }

    return(
        <Box sx={{display:'flex', padding:'20px', flexDirection:'column'}}>
            <Stack direction='row' spacing={1} alignItems='center' marginBottom={2}>
                <Typography variant="subtitle1">Type de graph:</Typography>
                <ButtonGroup variant="outlined">
                    {graphs.map(grap=><Button key={grap.value} variant={grap.value===graph_type?"contained":"outlined"} onClick={()=>settype(grap.value)}>{grap.label}</Button>)}
                </ButtonGroup>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center' marginBottom={1}>
                <TextField value={title} onChange={e=>settitle(e.target.value)} label='Titre' fullWidth sx={{minWidth:'120px'}}/>
                <Select multiple value={labels} onChange={e=>setlabels(e.target.value)} label='Colonnes' fullWidth sx={{minWidth:'200px'}}>
                    {props.data.map(data=>
                        <MenuItem key={data.label} value={data.label}>{data.label}</MenuItem>
                    )}
                </Select>
            </Stack>
            <Button variant="contained" onClick={downloadChart} style={{alignSelf:'end'}} disabled={labels.length<=0}>Télécharger</Button>
            <div id="chart_container"><Box sx={{width:'100%', height:'100%', minWidth:'500px', minHeight:'500px'}}>
                {graph_type==='line'?
                labels.length>0&&<Chart ref={chartRef} type='line' 
                data={{
                    labels: props.line_data.dates.map(date => moment.utc(date).format('yyyy-MM-DD')), 
                    datasets: props.line_data.data.filter(dt=>labels.includes(dt.label)).map((item, index) => ({
                        label: item.label,
                        data: item.values,
                        fill: false,
                        borderColor: chart_colors[index % chart_colors.length]
                    }))
                }}
                options={{
                    responsive:true, 
                    maintainAspectRatio:false, 
                    plugins:{
                        legend:{position:'right', title:{display: true, text:'Légende', color:'#222', font:{size:16, weight:'bold'}}},
                        title:{display: true, text: title, font:{size:20}, padding:{bottom:30}, color:'#000'}
                    },
                    scales: props.line_data.dates.length>8&&{
                        x: {
                            type: 'time',
                            time: {
                                unit: 'month'
                            }
                        }
                    }
                }}/>
                :(labels.length>0||graph_type==='pie')&&<Chart ref={chartRef} type={graph_type}
                data={{
                    labels:graph_type==='pie'&&props.tt_label&&labels.length<props.data.length?[props.tt_label,...labels].map((lb)=>lb+' '+(lb===props.tt_label?props.data.reduce((tt,v)=>tt+v.value,0):props.data.find(dt=>dt.label===lb).value).toFixed(2)+'€'): labels.map((lb)=>lb+' '+props.data.find(dt=>dt.label===lb).value.toFixed(2)+'€'), 
                    datasets:[{data: graph_type==='pie'&&props.tt_label&&labels.length<props.data.length?[props.data.filter(dt=>!labels.includes(dt.label)).reduce((tt,v)=>tt+v.value,0),...props.data.filter(dt=>labels.includes(dt.label)).map(dt=>dt.value)]:props.data.filter(dt=>labels.includes(dt.label)).map(dt=>dt.value), backgroundColor:chart_colors}]
                }}
                options={{responsive:true, maintainAspectRatio:false, 
                plugins:{
                    legend:graph_type==='pie'&&{position:'right', title:{display: true, text:'Légende', color:'#222', font:{size:16, weight:'bold'}}},
                    title:{display: true, text: title, font:{size:20}, padding:{bottom:30}, color:'#000'},
                    datalabels: {
                        color: '#fff',
                        formatter: function(value, context) {
                            return value;
                        }
                    }
                }}}/>
                }
            </Box></div>
        </Box>
    )
}